import { Quote } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { TESTIMONIALS } from "../../lib/site";

export const Testimonials = () => (
  <section className="relative bg-white py-24" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>What people say</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          Loved by teams and individuals alike.
        </h2>
        <p className="mt-4 text-sm text-slate-500">Placeholder testimonials — real reviews will appear here at launch.</p>
      </Reveal>

      <StaggerGroup className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <StaggerItem key={i}>
            <figure
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col rounded-3xl border border-slate-200 bg-background p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <Quote className="h-8 w-8 text-brand/20" />
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-slate-700">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-200 pt-5">
                {t.img ? (
                  <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover" loading="lazy" />
                ) : (
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-brand/10 font-display text-sm font-bold text-brand">
                    {t.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
                  </span>
                )}
                <div>
                  <p className="text-sm font-semibold text-ink">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default Testimonials;
